export type LLMProvider = 'qwen' | 'openai' | 'anthropic' | 'gemini'

export interface Agent {
  id: number;
  name: string;
  description: string;
  systemPromptId: number;
  conversationPromptId: number;
  llmProvider: LLMProvider;
  llmModel: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateAgentRequest {
  name: string;
  description: string;
  systemPromptId: number;
  conversationPromptId: number;
  llmProvider: LLMProvider;
  llmModel: string;
  isActive?: boolean;
}

export interface UpdateAgentRequest {
  id: number;
  name?: string;
  description?: string;
  systemPromptId?: number;
  conversationPromptId?: number;
  llmProvider?: LLMProvider;
  llmModel?: string;
  isActive?: boolean;
}

export interface LLMModel {
  id: string;
  name: string;
  description: string;
  pricing?: {
    input: number;
    output: number;
    unit: string;
  };
}

export interface LLMProviderConfig {
  id: LLMProvider;
  name: string;
  description: string;
  models: LLMModel[];
}

export const LLM_PROVIDERS: LLMProviderConfig[] = [
  {
    id: 'qwen',
    name: 'QWEN (Alibaba)',
    description: 'Modelos de Alibaba Cloud - Optimizado para Chinese/English',
    models: [
      {
        id: 'qwen-turbo',
        name: 'QWEN Turbo',
        description: 'Modelo rápido y eficiente (usa latest automáticamente)',
        pricing: { input: 0.0525, output: 0.21, unit: 'M tokens' }
      },
      {
        id: 'qwen-plus',
        name: 'QWEN Plus',
        description: 'Modelo balanceado entre velocidad y calidad (usa latest automáticamente)',
        pricing: { input: 0.42, output: 1.26, unit: 'M tokens' }
      },
      {
        id: 'qwen-max',
        name: 'QWEN Max',
        description: 'Modelo premium con máxima calidad (usa latest automáticamente)',
        pricing: { input: 1.68, output: 1.672, unit: 'M tokens' }
      }
    ]
  },
  {
    id: 'openai',
    name: 'OpenAI',
    description: 'Modelos GPT de OpenAI - Líder en la industria',
    models: [
      {
        id: 'gpt-4o-mini',
        name: 'GPT-4o Mini',
        description: 'Modelo compacto y económico',
        pricing: { input: 0.15, output: 0.6, unit: 'M tokens' }
      },
      {
        id: 'gpt-4o',
        name: 'GPT-4o',
        description: 'Modelo flagship multimodal',
        pricing: { input: 2.5, output: 10, unit: 'M tokens' }
      },
      {
        id: 'gpt-4-turbo',
        name: 'GPT-4 Turbo',
        description: 'GPT-4 optimizado para velocidad',
        pricing: { input: 10, output: 30, unit: 'M tokens' }
      },
      {
        id: 'gpt-4',
        name: 'GPT-4',
        description: 'Modelo base GPT-4',
        pricing: { input: 30, output: 60, unit: 'M tokens' }
      }
    ]
  },
  {
    id: 'anthropic',
    name: 'Anthropic Claude',
    description: 'Modelos Claude - Enfoque en seguridad y utilidad',
    models: [
      {
        id: 'claude-3-5-haiku-20241022',
        name: 'Claude 3.5 Haiku',
        description: 'Modelo rápido y económico',
        pricing: { input: 1, output: 5, unit: 'M tokens' }
      },
      {
        id: 'claude-3-5-sonnet-20241022',
        name: 'Claude 3.5 Sonnet',
        description: 'Modelo balanceado premium',
        pricing: { input: 3, output: 15, unit: 'M tokens' }
      },
      {
        id: 'claude-3-opus-20240229',
        name: 'Claude 3 Opus',
        description: 'Modelo más potente para tareas complejas',
        pricing: { input: 15, output: 75, unit: 'M tokens' }
      }
    ]
  },
  {
    id: 'gemini',
    name: 'Google Gemini',
    description: 'Modelos Gemini de Google - Multimodal avanzado',
    models: [
      {
        id: 'gemini-1.5-flash',
        name: 'Gemini 1.5 Flash',
        description: 'Modelo rápido y eficiente',
        pricing: { input: 0.075, output: 0.3, unit: 'M tokens' }
      },
      {
        id: 'gemini-1.5-pro',
        name: 'Gemini 1.5 Pro',
        description: 'Modelo premium con contexto extendido',
        pricing: { input: 1.25, output: 5, unit: 'M tokens' }
      }
    ]
  }
]
